/** Dialog presentation modes shared by every image preview. */
export const DIALOG_SIZES = {
  default: 'default',
  fullscreen: 'fullscreen',
} as const;

export type PreviewDialogSize =
  (typeof DIALOG_SIZES)[keyof typeof DIALOG_SIZES];

/** Controls how an image is rendered inside its preview dialog. */
export const DIALOG_IMAGE_SIZES = {
  fit: 'fit',
  natural: 'natural',
} as const;

export type DialogImageSize =
  (typeof DIALOG_IMAGE_SIZES)[keyof typeof DIALOG_IMAGE_SIZES];
